import { ProfileGroup } from '.'

export const REQUEST = 'PROFILE_GET_GROUP_START'
interface RequestAction {
  type: typeof REQUEST
  groupId: string
}

export const REQUEST_SUCCESS = 'PROFILE_GET_GROUP_SUCCESS'
interface RequestSuccessAction {
  type: typeof REQUEST_SUCCESS
  groupId: string
  group: ProfileGroup
}

export const REQUEST_FAILURE = 'PROFILE_GET_GROUP_FAILURE'
interface RequestFailureAction {
  type: typeof REQUEST_FAILURE
  groupId: string
  error: unknown
}

export type Action = RequestAction | RequestSuccessAction | RequestFailureAction
